import { FC } from "react";
import { Table } from "taltech-styleguide";
import { OverridenInput } from "../parameters/OverridenInput";

type Props = {
  tableItems: any[];
};

/**
 * Functional Component: OverrideValueTable
 *
 * This component renders a table that displays a list of items with the ability to override default values.
 * Each row in the table represents an item with columns for name, type, and an input for overriding the default value.
 *
 * Props:
 * @param {Props} props - The properties passed to the component.
 * @param {any[]} props.tableItems - An array of items to be displayed in the table.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the table with items and inputs for overriding default values.
 */
export const OverrideValueTable: FC<Props> = ({ tableItems }) => {
  return (
    <Table>
      <thead>
        <th>Name</th>
        <th>Type</th>
        <th>Override Default Value</th>
      </thead>
      <tbody>
        {tableItems !== undefined &&
          tableItems.map((item: any, index: number) => (
            <tr key={item.id + index}>
              <td>{item.name}</td>
              <td>{item.type}</td>
              <td>
                <OverridenInput id="typeParameters" index={index} />
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
};
